import { frontendURL } from 'dashboard/helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/plugins'),
      name: 'plugins_index',
      component: () =>
        import('dashboard/components-next/plugins/Plugins.vue'),
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
    {
      path: frontendURL('accounts/:accountId/plugins/:pluginId'),
      name: 'plugin_show',
      component: () =>
        import('dashboard/components-next/plugins/PluginView.vue'),
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
  ],
};
